import { Injectable } from '@angular/core';

import { alarmestorage } from "./data.service";

@Injectable()
export class Alarmeservice {

    constructor(
    ) { }

    //session
    setSessionStorage(item: any) {
        let object: string = JSON.stringify(item);
        sessionStorage.setItem(alarmestorage + '-new', object);
    }

    getSessionStorage() {
        let item: string = sessionStorage.getItem(alarmestorage + "-new");
        return JSON.parse(item);
    }

    clearSessionStorage() {
        sessionStorage.removeItem(alarmestorage + "-new");
    }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/rastreamentos/alarmes/shared/alarme.service.ts
 **/